import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { useForm, Controller, useWatch } from "react-hook-form";
import DataTable from "react-data-table-component";
import { customTableStyles } from "../../assets/CustomTableStyles";
import { get, post } from "../../services/api";
import { toast } from "react-toastify";
import Select from "react-select";
import TransferChallanHtml from "./TransferChallanHtml";
import { PdfGenerator } from "../../components/PdfGenerator/PdfGenerator";
import FullScreenLoader from "../../components/FullScreenLoader";

function StudentTransferOut() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");

  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    trigger,
    reset,
    getValues,
  } = useForm({
    defaultValues: {},
  });

  const [levelsData, setLevelsData] = useState([]);

  const [centerId, setCenterId] = useState(savedCenterId || null);
  const [targetCenterId, setTargetCenterId] = useState(null);
  const [selectedClassSectionId, setSelectedClassSectionId] = useState(null);
  const [selectedStudentId, setSelectedStudentId] = useState(null);

  const [centersData, setCentersData] = useState([]);
  const [targetCentersData, setTargetCentersData] = useState([]);
  const [classSectionsData, setClassSectionsData] = useState([]);
  const [studentsData, setStudentsData] = useState([]);
  const [transferredOutStudentsData, setTransferredOutStudentsData] = useState(
    []
  );

  const [triggerRerender, setTriggerRerender] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);

  const [selectedRow, setSelectedRow] = useState(null);
  const [isTransferChallan, setIsTransferChallan] = useState(true);
  const [classesData, setClassesData] = useState([]);
  const [sections, setSections] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState(null);
  const [selectedSectionId, setSelectedSectionId] = useState(null);

  const [isGenerateChallanModalVisible, setIsGenerateChallanModalVisible] =
    useState(false);
  const showGenerateChallanModal = () => setIsGenerateChallanModalVisible(true);
  const hideGenerateChallanModal = () => {
    setIsGenerateChallanModalVisible(false);
    setSelectedRow(null);

    reset({
      challanDate: "",
      dueDate: "",
    });
  };

  const [isModalVisible, setModalVisible] = useState(false);
  const showModal = () => setModalVisible(true);
  const hideModal = () => {
    setModalVisible(false);
    setSelectedRow(null);

    reset({
      centerId: getValues("centerId"),
      centerClassId: "",
      sectionId: "",
      studentTransferId: "",
      challanNo: "",
      isTransfer: true,
      createdBy: localStorage.getItem("userId"),
    });
  };

  useEffect(() => {
    fetchLevelData();
  }, [triggerRerender]);

  const fetchLevelData = async () => {
    try {
      const levelsResponse = await get(
        `Dropdown/GetAllOrganizationLevelsByOrganizationId?organizationId=${organizationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setLevelsData(levelsResponse);
    } catch (error) {
      console.error("Error fetching elements:", error);
    }
  };

  const fetchCenters = async () => {
    try {
      const response = await get(
        `Dropdown/GetAllCentersByOrganizationId?organizationId=${organizationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setCentersData(response);

      if (savedCenterId) {
        const selectedCenter = response.find(
          (center) => center.id === parseInt(savedCenterId, 10)
        );

        if (selectedCenter) {
          setValue("fromCenterId", {
            value: selectedCenter.id,
            label: selectedCenter.name,
          });
          setValue("centerIdPayModal", {
            value: selectedCenter.id,
            label: selectedCenter.name,
          });

          fetchClassSectionsByCenterId(savedCenterId);
          fetchClassesByCenterId(savedCenterId);
          fetchTransferredOutStudents(savedCenterId);
        }
      }
    } catch (error) {
      console.error("Error fetching centers:", error);
    }
  };

  useEffect(() => {
    fetchCenters();
  }, []);

  const fetchCentersByLevelAccountStringId = async (updatedAccountString) => {
    try {
      const response = await get(
        `Center/GetCenterByLevelAccountStringId?accountString=${updatedAccountString}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setTargetCentersData(response.center);
    } catch (error) {
      console.error("Error fetching feePlans:", error);
    }
  };

  const fetchClassSectionsByCenterId = async (centerId) => {
    try {
      if (centerId) {
        const response = await get(
          `ClassSection/GetAllClassSectionByCenterId?centerId=${centerId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setClassSectionsData(response);
      } else {
        setClassSectionsData([]);
      }
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  const fetchStudentsByClassSectionId = async () => {
    try {
      const response = await get(
        `Student/GetStudentByClassSectionIdAsync?classSectionId=${selectedClassSectionId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setStudentsData(response || []);
    } catch (error) {
      console.error("Error fetching students:", error);
    }
  };

  const fetchClassesByCenterId = async (centerId) => {
    try {
      if (centerId) {
        const response = await get(
          `CenterClass/GetClassCenterByCenterId?id=${centerId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setClassesData(response);
      } else {
        setClassesData([]);
      }
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  const getAllClassSectionsByClassIdAndCenterId = async (classId, centerId) => {
    try {
      if (classId && centerId) {
        const response = await get(
          `ClassSection/GetAllSectionByCenterClassIdAndCenterId?centerClassId=${classId}&centerId=${centerId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setSections(response);
      } else {
        setSections([]);
      }
    } catch (error) {
      console.error("Error fetching sections:", error);
    }
  };

  useEffect(() => {
    if (centerId && selectedClassId) {
      getAllClassSectionsByClassIdAndCenterId(selectedClassId, centerId);
    }
  }, [centerId, selectedClassId, triggerRerender]);

  const fetchTransferredOutStudents = async (centerId) => {
    try {
      const response = await get(
        `Student/GetStudentTransferOutList?centerId=${centerId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setTransferredOutStudentsData(response?.studentTransferList || []);
    } catch (error) {
      console.error("Error fetching students:", error);
    }
  };

  useEffect(() => {
    if (selectedClassSectionId) {
      fetchStudentsByClassSectionId();
    } else {
      setStudentsData([]);
    }
  }, [selectedClassSectionId]);

  const columns = [
    {
      name: "Sr No.",
      cell: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      sortable: false,
      width: "60px",
    },
    {
      name: "Student",
      selector: (row) => row.studentName,
      sortable: true,
      width: "150px",
    },
    {
      name: "From Center",
      selector: (row) => row.fromCenter,
      sortable: true,
      width: "150px",
    },
    {
      name: "To Center",
      selector: (row) => row.toCenter,
      sortable: true,
      width: "150px",
    },
    {
      name: "Trasfer Date",
      selector: (row) => row.transferDate.split("T")[0],
      sortable: true,
      width: "120px",
    },
    {
      name: "Challan No.",
      selector: (row) => row.challanId,
      sortable: true,
      width: "120px",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
    },
    {
      name: "Paid",
      selector: (row) => (row.isPaid ? "Yes" : "No"),
      sortable: true,
    },
    {
      name: "Challan Actions",
      width: "130px",
      selector: (row) => (
        <>
          <div className="d-flex gap-1">
            {!row.challanId && (
              <button
                type="button"
                className="btn btn-outline-primary py-1 px-2"
                onClick={() => handleGenerateChallanClick(row)}
              >
                Generate
              </button>
            )}

            {row.challanId && !row.isPaid && (
              <button
                type="button"
                className="btn btn-outline-primary py-1 px-2"
                onClick={() => handlePayClick(row, true)}
              >
                Pay
              </button>
            )}

            {row.challanId && (
              <>
                <button
                  type="button"
                  className="btn btn-primary py-1 px-2"
                  onClick={() => handlePrintClick(row.challanId)}
                >
                  Print
                </button>
              </>
            )}
          </div>
        </>
      ),
    },
  ];

  const saveData = async (data) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    const formdata = {
      fromCenterId: data?.fromCenterId?.value,
      classSectionId: data?.classSectionId?.value,
      studentId: data?.studentId?.value,
      toCenterId: data?.toCenterId?.value,
      createdBy: localStorage.getItem("userId"),
    };

    try {
      const response = await post(`Student/AddStudentTransferOut`, formdata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        setTriggerRerender((prev) => !prev);
        fetchTransferredOutStudents(centerId);
        reset({
          id: 0,
          fromCenterId: getValues("fromCenterId"),
          classSectionId: "",
          studentId: "",
          toCenterId: "",
          createdBy: localStorage.getItem("userId"),
          group: levelsData.map(() => null),
        });
      } else {
        toast.error(response.message || "Error!");
      }
    } catch (error) {
      console.error("Error saving category:", error);
    }
  };

  const selectedGroups = useWatch({
    control,
    name: "group",
    defaultValue: [],
  });

  useEffect(() => {
    const updatedAccountString = selectedGroups
      .map((group) => group?.code || "")
      .filter((code) => code)
      .join("-");

    setValue("accountString", updatedAccountString);

    trigger("accountString");

    if (updatedAccountString) {
      fetchCentersByLevelAccountStringId(updatedAccountString);
    }
  }, [selectedGroups, setValue]);

  const handleGenerateChallanClick = async (row) => {
    setIsGenerateChallanModalVisible(true);
    setSelectedRow(row);
    setValue("challanDate", new Date().toISOString().split("T")[0]);
  };

  const submitGenerateChallan = async () => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    const isValid = await trigger(["challanDate", "dueDate"]);
    if (!isValid) {
      return;
    }

    const challanDate = getValues("challanDate");
    const dueDate = getValues("dueDate");

    const formData = {
      challanDate,
      dueDate,
      studentId: selectedRow.studentId,
      createdBy: localStorage.getItem("userId"),
    };

    try {
      const response = await post(`Student/GenerateTransferChallan`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        setTriggerRerender((prev) => !prev);
        hideGenerateChallanModal();
        fetchTransferredOutStudents(centerId);
      } else {
        toast.error(response.message || "Error!");
      }
    } catch (error) {
      console.error("Error saving:", error);
    }
  };

  const fetchChallanData = async (regNo) => {
    setLoading(true);
    try {
      const response = await get(
        `Student/PrintTransferChallan?ChallanNo=${regNo}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.isSuccess) {
        return response?.transferChallan;
      } else {
        throw new Error("Failed to fetch challan data.");
      }
    } catch (error) {
      console.error("Error fetching challan data:", error);
      throw error;
    }
  };

  const handlePrintClick = async (challanId) => {
    if (!challanId) {
      alert("Please select challan.");
      return;
    }

    setLoading(true);

    try {
      const challanData = await fetchChallanData(challanId);

      const container = document.createElement("div");
      container.style.position = "absolute";
      container.style.left = "-9999px";
      document.body.appendChild(container);

      const root = ReactDOM.createRoot(container);
      root.render(
        <div>
          <TransferChallanHtml challanData={challanData} />
        </div>
      );

      await new Promise((resolve) => setTimeout(resolve, 200));

      await PdfGenerator(container);

      root.unmount();
      document.body.removeChild(container);
    } catch (error) {
      console.error("Error generating PDF:", error);
      alert("Failed to generate PDF. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handlePayClick = async (row, payType) => {
    setModalVisible(true);
    fetchCenters();
    setSelectedRow(row);
    setIsTransferChallan(payType);
  };

  const submitPayChallan = async (data) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    const isValid = await trigger([
      "centerIdPayModal",
      "centerClassId",
      "sectionId",
    ]);
    if (!isValid) {
      return;
    }

    const centerId = getValues("centerIdPayModal");
    const centerClassId = getValues("centerClassId");
    const sectionId = getValues("sectionId");

    const formData = {
      centerId: centerId?.value,
      centerClassId: centerClassId?.value,
      sectionId: sectionId?.value,
      studentTransferId: selectedRow.studentTransferId,
      challanNo: selectedRow.challanId,
      isTransfer: isTransferChallan,
      createdBy: localStorage.getItem("userId"),
    };

    try {
      const response = await post(`Student/PayTransferChallan`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        setTriggerRerender((prev) => !prev);
        hideModal();
        fetchTransferredOutStudents(centerId?.value);
      } else {
        toast.error(response.message || "Error!");
      }
    } catch (error) {
      console.error("Error saving:", error);
    }
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Pupil Transfer</h2>
      </div>

      <form className="row g-3" onSubmit={handleSubmit(saveData)}>
        <div className="col-md-4">
          <div className="card">
            <div className="card-body">
              <div className="row g-3">
                <div className="d-flex">
                  <h5 className="mb-0">Select Pupil</h5>
                </div>
                <div className="col-md-6">
                  <label className="form-label">
                    From Center
                    <span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="fromCenterId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={centersData.map((center) => ({
                          value: center.id,
                          label: center.name,
                        }))}
                        isDisabled={savedCenterId !== "0"}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue("fromCenterId", null);
                          } else {
                            setValue("fromCenterId", selectedOption);
                            setCenterId(selectedOption.value);
                            fetchClassSectionsByCenterId(selectedOption.value);
                            fetchTransferredOutStudents(selectedOption.value);
                          }
                          setClassSectionsData([]);
                          setValue("classSectionId", null);
                          setSelectedClassSectionId(null);
                          setStudentsData([]);
                          setValue("studentId", null);
                          setSelectedStudentId(null);

                          trigger("fromCenterId");
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        // isClearable
                      />
                    )}
                  />
                  {errors.fromCenterId && (
                    <small className="text-danger">
                      {errors.fromCenterId.message}
                    </small>
                  )}
                </div>
                <div className="m-0"></div>
                <div className="col-md-6">
                  <label className="form-label">
                    Classs - Section
                    <span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="classSectionId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={classSectionsData.map((classSection) => ({
                          value: classSection.id,
                          label: classSection.name,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue("classSectionId", null);
                            setSelectedClassSectionId(null);
                          } else {
                            setValue("classSectionId", selectedOption);
                            setSelectedClassSectionId(selectedOption.value);
                          }
                          setValue("studentId", null);
                          setSelectedStudentId(null);
                          setStudentsData([]);
                          trigger("classSectionId");
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        // isClearable
                      />
                    )}
                  />
                  {errors.classSectionId && (
                    <small className="text-danger">
                      {errors.classSectionId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label">
                    Pupil<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="studentId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={studentsData.map((student) => ({
                          value: student.id,
                          label: student.studentName + " — " + student.code,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setSelectedStudentId(null);
                            setValue("studentId", null);
                          } else {
                            setSelectedStudentId(
                              selectedOption ? selectedOption.value : null
                            );
                            setValue("studentId", selectedOption);
                          }
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                      />
                    )}
                  />
                  {errors.studentId && (
                    <small className="text-danger">
                      {errors.studentId.message}
                    </small>
                  )}
                </div>

                <div className="col-12">
                  <hr className="mt-1 mb-0" />
                </div>

                {levelsData.length ? (
                  <>
                    <div className="col-12">
                      <>
                        <h5 className="mb-2">Levels</h5>
                        <div className="row g-3">
                          {levelsData.map((group, groupIndex) => (
                            <div className="col-6" key={groupIndex}>
                              <Controller
                                name={`group[${groupIndex}]`}
                                control={control}
                                rules={{ required: "This field is required." }}
                                render={({ field }) => (
                                  <Select
                                    {...field}
                                    options={group.map((element) => ({
                                      value: element.levelDetailId,
                                      label: element.name,
                                      code: element.code,
                                    }))}
                                    onChange={(selectedOption, actionMeta) => {
                                      if (actionMeta.action === "clear") {
                                        setValue(`group[${groupIndex}]`, null);
                                      } else {
                                        setValue(
                                          `group[${groupIndex}]`,
                                          selectedOption || {
                                            value: 0,
                                            label: "",
                                            code: "",
                                          }
                                        );
                                      }
                                      trigger(`group[${groupIndex}]`);
                                    }}
                                    className="react-select-style"
                                    classNamePrefix="react-select-style-pref"
                                    isClearable
                                  />
                                )}
                              />
                              {errors.group?.[groupIndex] && (
                                <small className="text-danger">
                                  {errors.group[groupIndex].message}
                                </small>
                              )}
                            </div>
                          ))}
                        </div>
                      </>
                    </div>
                  </>
                ) : (
                  <small className="text-danger">
                    Please create levels first.
                  </small>
                )}
                <div className="col-md-12 mt-3 d-none">
                  <label className="form-label">
                    Account String
                    <span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register("accountString", {
                      required: "This field is required.",
                    })}
                    type="text"
                    className="form-control"
                    placeholder=""
                    disabled={true}
                  />
                  {errors.accountString && (
                    <small className="text-danger">
                      {errors.accountString.message}
                    </small>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label">
                    To Center<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name={`toCenterId`}
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={targetCentersData.map((center) => ({
                          value: center.id,
                          label: center.name,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue(`toCenterId`, null);
                          } else {
                            setValue(
                              `toCenterId`,
                              selectedOption || { value: 0, label: "" }
                            );
                            setTargetCenterId(selectedOption.value);
                          }
                          trigger(`toCenterId`);
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.toCenterId && (
                    <small className="text-danger">
                      {errors.toCenterId.message}
                    </small>
                  )}
                </div>
                <div className="col-12">
                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Transfer" : "Transfer"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-8">
          <div className="card">
            <div className="card-body">
              <h5 className="mb-2">Pupils Transferred Out</h5>
              <div className="table-container fixed-last-column-table">
                <DataTable
                  columns={columns}
                  data={transferredOutStudentsData}
                  pagination
                  dense
                  customStyles={customTableStyles}
                  onChangePage={setCurrentPage}
                  onChangeRowsPerPage={setRowsPerPage}
                />
              </div>
            </div>
          </div>
        </div>
      </form>

      {isModalVisible && (
        <>
          <div
            className="modal fade show"
            tabIndex="-1"
            style={{ display: "block" }}
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <form>
                  <div className="modal-header">
                    <h5 className="mb-0">Pay Transfer Challan</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={hideModal}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="row gx-2 gy-3">
                      <div className="col-md-6">
                        <label className="form-label">
                          Center
                          <span className="text-danger fs-9">*</span>
                        </label>
                        <Controller
                          name="centerIdPayModal"
                          control={control}
                          rules={{ required: "This field is required." }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={centersData.map((center) => ({
                                value: center.id,
                                label: center.name,
                              }))}
                              isDisabled={savedCenterId !== "0"}
                              onChange={(selectedOption, actionMeta) => {
                                if (actionMeta.action === "clear") {
                                  setValue("centerIdPayModal", null);
                                } else {
                                  setValue("centerIdPayModal", selectedOption);
                                  setCenterId(selectedOption.value);
                                  fetchClassesByCenterId(selectedOption.value);
                                }
                                setClassesData([]);
                                setValue("centerClassId", null);
                                setSelectedClassId(null);
                                trigger("centerIdPayModal");
                              }}
                              className="react-select-style"
                              classNamePrefix="react-select-style-pref"
                            />
                          )}
                        />
                        {errors.centerIdPayModal && (
                          <small className="text-danger">
                            {errors.centerIdPayModal.message}
                          </small>
                        )}
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">
                          Student
                          <span className="text-danger fs-9">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={selectedRow.studentName}
                          disabled
                        />
                      </div>
                      {/* <div className="col-md-6">
                        <label className="form-label">
                          Class<span className="text-danger fs-9">*</span>
                        </label>
                        <Controller
                          name="centerClassId"
                          control={control}
                          rules={{ required: "This field is required." }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={classesData.map((classItem) => ({
                                value: classItem.id,
                                label: classItem.name,
                              }))}
                              onChange={(selectedOption, actionMeta) => {
                                if (actionMeta.action === "clear") {
                                  setValue("centerClassId", null);
                                  setSelectedClassId(null);
                                  setSections([]);
                                } else {
                                  setValue("centerClassId", selectedOption);
                                  setSelectedClassId(selectedOption.value);
                                }
                                trigger("centerClassId");
                              }}
                              className="react-select-style"
                              classNamePrefix="react-select-style-pref"
                              isClearable
                            />
                          )}
                        />
                        {errors.centerClassId && (
                          <small className="text-danger">
                            {errors.centerClassId.message}
                          </small>
                        )}
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">
                          Section<span className="text-danger fs-9">*</span>
                        </label>
                        <Controller
                          name="sectionId"
                          control={control}
                          rules={{ required: "This field is required." }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={sections.map((sectionItem) => ({
                                value: sectionItem.id,
                                label: sectionItem.name,
                              }))}
                              onChange={(selectedOption, actionMeta) => {
                                if (actionMeta.action === "clear") {
                                  setValue("sectionId", null);
                                  setSelectedSectionId(null);
                                  setSections([]);
                                } else {
                                  setValue("sectionId", selectedOption);
                                  setSelectedSectionId(selectedOption.value);
                                }
                                trigger("sectionId");
                              }}
                              className="react-select-style"
                              classNamePrefix="react-select-style-pref"
                              isClearable
                            />
                          )}
                        />
                        {errors.sectionId && (
                          <small className="text-danger">
                            {errors.sectionId.message}
                          </small>
                        )}
                      </div> */}
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      onClick={submitPayChallan}
                    >
                      Pay
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={hideModal}
                    >
                      Close
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}

      {isGenerateChallanModalVisible && (
        <>
          <div
            className="modal fade show"
            tabIndex="-1"
            style={{ display: "block" }}
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <form>
                  <div className="modal-header">
                    <h5 className="mb-0">Generate Challan</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={hideGenerateChallanModal}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="row gx-2 gy-3">
                      <div className="col-md-6">
                        <label className="form-label">
                          Challan Date
                          <span className="text-danger fs-9">*</span>
                        </label>
                        <input
                          {...register(`challanDate`, {
                            required: "This field is required.",
                          })}
                          type="date"
                          className="form-control"
                          disabled={true}
                        />
                        {errors.challanDate && (
                          <small className="text-danger">
                            {errors.challanDate.message}
                          </small>
                        )}
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">
                          Due Date
                          <span className="text-danger fs-9">*</span>
                        </label>
                        <input
                          {...register(`dueDate`, {
                            required: "This field is required.",
                            validate: {
                              futureDate: (value) => {
                                const selectedDate = new Date(value);
                                const today = new Date();
                                today.setHours(0, 0, 0, 0);
                                return (
                                  selectedDate >= today ||
                                  "Please select a valid date."
                                );
                              },
                            },
                          })}
                          type="date"
                          className="form-control"
                        />
                        {errors.dueDate && (
                          <small className="text-danger">
                            {errors.dueDate.message}
                          </small>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      onClick={submitGenerateChallan}
                    >
                      Save
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={hideGenerateChallanModal}
                    >
                      Close
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}

      {loading && <FullScreenLoader />}
    </>
  );
}

export default StudentTransferOut;
